module.exports = __webpack_public_path__ + "img/newance-logo-small.347ee40d.svg";